/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationsResponseGetRecordsList } from '../../models/organizations-response-get-records-list';

export interface LocationsControllerGetOrganizations$Params {
  countryCode?: string;
}

export function locationsControllerGetOrganizations(http: HttpClient, rootUrl: string, params?: LocationsControllerGetOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationsResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, locationsControllerGetOrganizations.PATH, 'get');
  if (params) {
    rb.query('countryCode', params.countryCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationsResponseGetRecordsList>;
    })
  );
}

locationsControllerGetOrganizations.PATH = '/planning-projects/v1-develop/locations/organizations';
